/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type GiftcardCard_viewer$ref: FragmentReference;
declare export opaque type GiftcardCard_viewer$fragmentType: GiftcardCard_viewer$ref;
export type GiftcardCard_viewer = {|
  +account: ?{|
    +eventPurchases: ?{|
      +giftcards: ?$ReadOnlyArray<?{|
        +code: ?string,
        +initialValue: ?any,
      |}>
    |}
  |},
  +$refType: GiftcardCard_viewer$ref,
|};
export type GiftcardCard_viewer$data = GiftcardCard_viewer;
export type GiftcardCard_viewer$key = {
  +$data?: GiftcardCard_viewer$data,
  +$fragmentRefs: GiftcardCard_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "GiftcardCard_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "eventId",
      "type": "ID"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "account",
      "storageKey": null,
      "args": null,
      "concreteType": "Account",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "eventPurchases",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "byStartnumber",
              "value": true
            },
            {
              "kind": "Variable",
              "name": "eventId",
              "variableName": "eventId"
            }
          ],
          "concreteType": "EventPurchases",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "giftcards",
              "storageKey": null,
              "args": null,
              "concreteType": "Giftcard",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "code",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "initialValue",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'e65a591b3acf613a295f6db4ffe89635';

module.exports = node;
